export default {
    navigationBarTitleText: "进度",
  };
  